import { OrgRoles, Roles } from "@aura-frontend/omnibus-az-client";

export type Role = OrgRoles | Roles;

export type RoleOption = {
  value: Role;
  label: string;
};

export type OrganizationRoles = Extract<
  OrgRoles,
  "account_owner" | "staff_admin" | "staff" | "tagger"
>;

export const RoleOptions: Record<OrganizationRoles, string> = {
  account_owner: "Account Owner",
  staff_admin: "Staff Admin",
  staff: "Staff",
  tagger: "Tagger",
};

export const UserRoleOptions: Record<Roles, string> = {
  magnus_super_admin: "Magnus Super Admin",
  magnus_admin: "Magnus Admin",
  aura_admin: "Aura Admin",
  aura_super_admin: "Aura Super Admin",
  report_upload: "Report Upload",
  report_download_raw: "Report Download Raw",
  device_data_download: "Device Data Download",
};

export const basePermissions: Record<OrganizationRoles, OrgRoles[]> = {
  account_owner: ["staff_admin", "staff", "tagger"],
  staff_admin: ["staff", "tagger"],
  staff: ["tagger"],
  tagger: [],
};

export const roleOptionToOrgRolesMapping: Record<
  OrganizationRoles,
  OrgRoles[]
> = {
  account_owner: ["unverified_account_owner"],
  staff_admin: ["staff_admin", "staff", "tagger"],
  staff: ["staff", "tagger"],
  tagger: ["tagger"],
};

/*
 * The order of roles in this array is important because we are going to display
 * only the one with most privileges in the table. The roles are listed from the most
 * important ("account_owner") to the least important ("tagger").
 */
export const organizationRolesHierarchy: OrganizationRoles[] = [
  "account_owner",
  "staff_admin",
  "staff",
  "tagger",
];

export const adminRolesHierarchy: Roles[] = [
  "magnus_super_admin",
  "aura_super_admin",
  "magnus_admin",
  "aura_admin",
];
